import { render, staticRenderFns } from "./TwilioVentas.vue?vue&type=template&id=9c899658&scoped=true"
import script from "./TwilioVentas.vue?vue&type=script&lang=js"
export * from "./TwilioVentas.vue?vue&type=script&lang=js"
import style0 from "./TwilioVentas.vue?vue&type=style&index=0&id=9c899658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c899658",
  null
  
)

export default component.exports